import { openUrl } from './open-url';

/**
 * Download a file directly, hiding the source URL and forcing a download instead
 * of opening the file in a new tab.
 *
 * The anchor `download` attribute is ignored by browsers for cross-origin URLs
 * (e.g. our CDN), which is why iPad/Safari opened PDFs in a new tab instead of
 * downloading them. Fetching the file as a blob and downloading the object URL
 * works around that — same approach as the RYC Essentials calendar download.
 *
 * Falls back to opening the URL (Safari-aware) if the fetch fails, e.g. CORS.
 */
export const downloadFileFromUrl = async (url: string, filename: string): Promise<void> => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.status}`);
    }
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.append(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    openUrl(url);
  }
};
